// /* global CookieInformation */
// export default function({ $gtm }) {
//   window.addEventListener(
//     'CookieInformationConsentGiven',
//     function() {
//       if (CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
//         console.log('GTM INIT!')

//         $gtm.init(process.env.GTM_ID)
//         // Place cookie-setting script here.
//         // Or some other javascript function you want to fire on consent.
//       }
//     },
//     false
//   )
// }

/* global CookieInformation */
// export default function({ $gtm }) {
//   if (process.client) {
//     window.addEventListener(
//       'CookieInformationConsentGiven',
//       function() {
//         if (CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
//           console.log('GTM consent granted — initializing');

//           window.dataLayer = window.dataLayer || [];
//           window.dataLayer.push({
//             event: 'consent_update',
//             ad_storage: 'granted',
//             analytics_storage: 'granted',
//             ad_user_data: 'granted',
//             ad_personalization: 'granted'
//           });

//           $gtm.init(process.env.GTM_ID);
//         } else {
//           console.log('Marketing consent not granted, GTM not initialized');
//         }
//       },
//       false
//     );
//   }
// }

export default function({ $gtm }) {
  if (process.client) {
    window.addEventListener(
      'CookieInformationConsentGiven',
      function() {
        if (CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
          console.log('GTM consent granted — initializing');

          window.dataLayer = window.dataLayer || [];
          window.gtag =
            window.gtag ||
            function() {
              window.dataLayer.push(arguments);
            };

          window.gtag('consent', 'update', {
            ad_storage: 'granted',
            analytics_storage: 'granted',
            ad_user_data: 'granted',
            ad_personalization: 'granted'
          });

          window.dataLayer.push({ event: 'consent_update' });

          $gtm.init(process.env.GTM_ID);
        } else {
          console.log('Marketing consent not granted, GTM not initialized');
        }
      },
      false
    );
  }
}
